export default __webpack_public_path__ + "static/img/hero.a2b6dd3.png";